import React, { useEffect } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProjectLandingKpi from "./ProjectLandingKpi";
import ScheduleOverview from "./ScheduleOverview";
import CostOverview from "./CostOverview";
import Invoice from "./Invoice";
import RiskOverview from "./RiskOverview";
import QualityOverview from "./QualityOverview";
import SafetyOverview from "./SafetyOverview";
import { useLazyGetAverageRiskRatingQuery, useLazyGetRiskOverviewQuery } from "store/slices/apis/riskDashboardSlice";
import { useParams } from "react-router-dom";
import { useGetScheduleKpisQuery } from "store/slices/apis/scheduleSlice";
import { useGetCostKpisQuery } from "store/slices/apis/costSlice";
import { useGetNCRStatusCountQuery } from "store/slices/apis/ncrLogApiSlice";
import BusinessPipelineTable from "components/BusinessPipelineTable";
import { BusinessPipelineMock } from "mockdata/BusinessPipelineMock"
import EnterprisePageShell from "components/EnterprisePageShell";
import { enterpriseTokens } from "styles/theme";

// const kpis = [
//     {
//         key: "project-progress",
//         label: "Project Progress",
//         type: "progress",
//         plan: 24.99,
//         actual: 20.37,
//         bg: "#FEC7C7",
//         iconBg: "#FA5A7D",
//         unit: "%"

//     },
//     {
//         key: "project-start-date",
//         label: "Project Start Date",
//         value: "2024-11-21T00:00:00",
//         type: "date",
//         bg: "#FFF4DE",
//         iconBg: "#FF947A"
//     },
//     {
//         key: "project-end-date",
//         label: "Project End Date",
//         value: "2026-11-26T00:00:00",
//         type: "date",
//         bg: "#FFF4DE",
//         iconBg: "#FF947A"
//     },
//     {
//         key: "anticipate-end-date",
//         label: "Anticipate End Date",
//         value: "2027-04-29T00:00:00",
//         type: "date",
//         bg: "#FEC7C7",
//         iconBg: "#FA5A7D",
//     },
//     {
//         key: "project-value",
//         label: "Project Value",
//         value: "327 Cr",
//         type: "cost",
//         bg: "#FFF4DE",
//         iconBg: "#FF947A"
//     },
//     {
//         key: "project-earned-value",
//         label: "Project Earned Value",
//         plan: 72.58,
//         actual: 59.17,
//         type: "progress",
//         bg: "#FEC7C7",
//         iconBg: "#FA5A7D",
//         unit: "Cr."
//     },
//     // {
//     //     key: "critical-activities-variance",
//     //     label: "Critical Activities Variance",
//     //     value: "23%",
//     //     type: "percentage",
//     //     bg: "#FFF4DE",
//     //     iconBg: "#FF947A",
//     //     subText: "from last month",
//     // },
// ]

const kpiData = {
    planProgress: 24.99,
    actualProgress: 20.37,
    completed: 1,
    missed: 0,
    total: 4,
}

// const costKpiData = [
//     {
//         label: "Baseline Cost",
//         value: "327 Cr",
//         key: "baseline-cost",
//         color: "#0088FF"
//     },
//     {
//         label: "Estimate at Completion  (EAC)",
//         value: "327 Cr",
//         key: "estimate-at-completion",
//         color: "#34C759"
//     },
//     // {
//     //     label: "Estimate to Completion  (ETC)",
//     //     value: "233.92 Cr",
//     //     key: "estimate-to-completion",
//     //     color: "#FF8D28"
//     // },
// ]


const ProjectLanding = () => {

    const { projectId } = useParams();
    const navigate = useNavigate();
    const showPipeline = projectId == "61bf1905-4332-4994-8e0a-f0c6002f701e" ? true : false;

    const [riskOverViewTrigger, { data: riskOverViewData }] = useLazyGetRiskOverviewQuery();
    const [riskRatingTrigger, { data: riskRatingData }] = useLazyGetAverageRiskRatingQuery();
    const { data: scheduleKpiData, error: scheduleKpiError, isLoading: scheduleKpiLoading } = useGetScheduleKpisQuery({ projectId });
    const { data: costKpiData, error: costKpiError, isLoading: costKpiLoading } = useGetCostKpisQuery({ projectId })
    const { data: ncrData, error: ncrIsError, isLoading: ncrIsLoading } = useGetNCRStatusCountQuery(projectId)

    useEffect(() => {
        riskOverViewTrigger(projectId);
        riskRatingTrigger(projectId);
    }, []);

    return (
        <EnterprisePageShell
            eyebrow="Project Control Room"
            title="Project health overview"
            description="Executive snapshot of schedule, cost, quality, safety, and risk signals for faster delivery decisions."
            meta={
                <>
                    {[
                        ["Schedule", scheduleKpiLoading ? "Loading" : scheduleKpiError ? "Check" : "Live"],
                        ["Cost", costKpiLoading ? "Loading" : costKpiError ? "Check" : "Live"],
                        ["Risk", riskOverViewData ? "Synced" : "Pending"],
                    ].map(([label, value]) => (
                        <Box key={label} sx={{ px: 1.5, py: 0.9, borderRadius: "3px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.14)", minWidth: 112 }}>
                            <Typography sx={{ color: "#CBD5E1", fontSize: 11, fontWeight: 600, textTransform: "uppercase" }}>{label}</Typography>
                            <Typography sx={{ color: "#FFFFFF", fontSize: 18, fontWeight: 700 }}>{value}</Typography>
                        </Box>
                    ))}
                </>
            }
        >
            {/* {showPipeline && (
            <Grid container spacing={1.5} sx={{ m: 1.5, mt: 2 }}>
                <Grid size={12}>
                    <BusinessPipelineTable
                        rows={BusinessPipelineMock}
                        isFetching={false}
                        isError={false}
                        asOnDate="2026-02-06"
                    />
                </Grid>
            </Grid>)} */}
            {/* {!showPipeline && ( */}
            <Grid
                container
                spacing={2}
                sx={{
                    "& > .MuiGrid-root": {
                        minWidth: 0,
                    },
                    "& .MuiCard-root": {
                        borderRadius: "3px",
                        border: `1px solid ${enterpriseTokens.lineSoft}`,
                        boxShadow: "0 12px 34px rgba(15, 23, 42, 0.07)",
                    },
                }}
            >
                <Grid size={12} >
                    <ProjectLandingKpi scheduelKpi={scheduleKpiData} costKpi={costKpiData} isLoading={scheduleKpiLoading || costKpiLoading} scheduleKpiError={scheduleKpiError} costKpiError={costKpiError} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <ScheduleOverview kpiData={kpiData} scheduleKpi={scheduleKpiData} isLoading={scheduleKpiLoading} error={scheduleKpiError} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <CostOverview costKpi={costKpiData} isLoading={costKpiLoading} error={costKpiError} />
                </Grid>
                <Grid size={{ md: 6 }} >
                    <QualityOverview ncrData={ncrData} isLoading={ncrIsLoading} error={ncrIsError} />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <SafetyOverview />
                </Grid>
                <Grid size={{ md: 6 }}>
                    <RiskOverview data={riskOverViewData} riskRatingData={riskRatingData} />
                </Grid>

                {/* <Grid size={{ md: 6 }}>
                    <Invoice />
                </Grid> */}
            </Grid>
            {/* )} */}

        </EnterprisePageShell>
    );
};

export default ProjectLanding;
